module.exports = __webpack_public_path__ + "static/media/empty-documents.17cf9bdc.svg";